import { useContext } from 'react';
import { PaginationHook } from '../types';
import { PaginationFilterPersonsContext } from '../helpers/context';

export const usePaginationFilterPersons = (): PaginationHook | undefined => {
	return useContext(PaginationFilterPersonsContext);
};
